module.exports = __webpack_public_path__ + "img/walls-sign.b0dea81d.png";